export enum NotificationLevelEnum {
    "None" = 0,
    "OnlyMine" = 1,
    "MyGroups" = 2,
    "All" = 3
}